import React, { useState } from 'react';

// Interface for CommonLayout props
interface CommonLayoutProps {
    children: React.ReactNode;
    className?: string;
}

// Common Layout Component
const CommonLayout: React.FC<CommonLayoutProps> = ({ children, className = '' }) => {
    return (
        <section className={`p-6 ${className}`}>
            <div className="bg-white p-6 flex flex-col gap-4 mx-auto shadow-md rounded-lg">
                {children}
            </div>
        </section>
    );
};

export default CommonLayout;